// JS for block-specific behavior only
console.log('res copy framed block loaded');